import IpSetIconImageDark from "./../../icons/default/ipsetDark.png";

import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const IpSetDarkIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return <img style={style} className={className} src={IpSetIconImageDark} />;
};
